import style from "./style.module.scss";

export default function PackageCard(props) {
  const { children, ...rest } = props;
  return (
    <div {...rest}>
      <div className={style.package_card}>{children}</div>
    </div>
  );
}
